import { ReferralCard } from "@/pages/Portal";
import { AccountLayout } from "@/components/account/AccountLayout";
import { usePageMeta } from "@/hooks/usePageMeta";

export default function AccountReferrals() {
    usePageMeta({ title: "Referrals · NOXN", description: "Give $250, get $250 — share your NOXN referral link." });
    return (
        <AccountLayout title="Referrals">
            <div data-testid="account-referrals-page" className="max-w-3xl [&>div]:mt-0">
                <ReferralCard />
            </div>
        </AccountLayout>
    );
}
